import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, {
  Path,
  Defs,
  LinearGradient,
  Stop,
  Rect,
  G,
  ClipPath,
} from "react-native-svg";
import appStyles from "../../../../appStyles";

export default function EditWhitePencil(props) {
  const width = props.width || 30;
  const height = props.height || 30;
  const fillColor = props.fillColor || "#FFF";

  return (
    <TouchableOpacity {...props} style={[appStyles.iconContainer, props.style]}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G clipPath="url(#clip0_journal_icon)">
          <Path
            d="M24.0087 15.9913L17.1337 9.11632C16.6449 8.62757 15.8549 8.62757 15.3662 9.11632L6.61619 17.8663C6.45619 18.0263 6.34244 18.2276 6.28744 18.4463L5.03744 23.4463C4.93119 23.8726 5.05619 24.3226 5.36619 24.6338C5.60369 24.8713 5.92244 25.0001 6.24994 25.0001C6.35119 25.0001 6.45244 24.9876 6.55369 24.9626L11.5537 23.7126C11.7737 23.6576 11.9737 23.5438 12.1337 23.3838L19.9999 15.5176L21.3574 16.8751L17.2412 20.9913C16.7524 21.4801 16.7524 22.2701 17.2412 22.7588C17.7299 23.2476 18.5199 23.2476 19.0087 22.7588L24.0087 17.7588C24.4974 17.2701 24.4974 16.4801 24.0087 15.9913Z"
            fill="url(#paint0_linear_journal_icon)"
          />
          <Path
            d="M18.9014 7.34875L22.6514 11.0988L24.2239 9.52625C25.2589 8.49125 25.2589 6.81125 24.2239 5.77625C23.1889 4.74125 21.5089 4.74125 20.4739 5.77625L18.9014 7.34875Z"
            fill="url(#paint1_linear_journal_icon)"
          />
        </G>
        <Defs>
          <LinearGradient
            id="paint0_linear_journal_icon"
            x1="5.00024"
            y1="12.2739"
            x2="11.96"
            y2="29.2292"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor={fillColor} />
            <Stop offset="1" stopColor={fillColor} />
          </LinearGradient>
          <LinearGradient
            id="paint1_linear_journal_icon"
            x1="18.9014"
            y1="6.32262"
            x2="21.8371"
            y2="12.3213"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor={fillColor} />
            <Stop offset="1" stopColor={fillColor} />
          </LinearGradient>
          <ClipPath id="clip0_journal_icon">
            <Rect
              width="20"
              height="20"
              fill="white"
              transform="translate(5 5)"
            />
          </ClipPath>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
